import { showErrorToast } from "@fuse/sharedComponents/themeToast/toastUtils"
import { EventDocData } from "@letshang/constants"
import { get } from "lodash-es"
import { useRecoilState } from "recoil"

import {
  buyTicketsSessionState,
  EBuyTicketSessionKeyType,
} from "@fuse/recoil/events"

import { EBuyTicketSessionKeys } from "@fuse/pages/eventSignUp/BuyTickets/utils"

export const useBuyTicketsSession = (eventDetail?: any) => {
  const [sessionData, setSessionData] = useRecoilState(buyTicketsSessionState)

  const setBuyTicketsSessionItem = (
    key: EBuyTicketSessionKeyType,
    value: any,
  ) => {
    setSessionData((prev) => ({ ...prev, [key]: value }))
  }

  const getBuyTicketsSessionItem = (key: EBuyTicketSessionKeyType) => {
    return sessionData[key]
  }

  const removeBuyTicketsSessionItem = (key: EBuyTicketSessionKeyType) => {
    setSessionData((prev) => {
      const newData = { ...prev }
      delete newData[key]
      return newData
    })
  }

  const clearAllBuyTicketsSession = () => {
    setSessionData({})
  }

  const totalTicketQuantity = get(eventDetail, "totalTicketQuantity", 0)
  const totalPurchasedTickets = get(eventDetail, "totalPurchasedTickets", 0)

  const handleAddQuantity = (id: string) => {
    const availableTickets = totalTicketQuantity - totalPurchasedTickets
    const currentTotalQuantity = sessionData[
      EBuyTicketSessionKeys.EVENTS_TICKETS
    ].reduce((sum, ticket) => sum + ticket.quantity, 0)

    if (currentTotalQuantity < availableTickets) {
      setSessionData((prevState) => ({
        ...prevState,
        [EBuyTicketSessionKeys.EVENTS_TICKETS]: prevState[
          EBuyTicketSessionKeys.EVENTS_TICKETS
        ].map((ticket) =>
          ticket.id === id
            ? { ...ticket, quantity: ticket.quantity + 1 }
            : ticket,
        ),
      }))
    } else {
      showErrorToast("No more tickets available")
    }
  }

  const handleSubtractQuantity = (id: string) => {
    setSessionData((prevState) => ({
      ...prevState,
      [EBuyTicketSessionKeys.EVENTS_TICKETS]: prevState[
        EBuyTicketSessionKeys.EVENTS_TICKETS
      ].map((ticket) =>
        ticket.id === id && ticket.quantity > 0
          ? { ...ticket, quantity: ticket.quantity - 1 }
          : ticket,
      ),
    }))
  }

  return {
    setBuyTicketsSessionItem,
    getBuyTicketsSessionItem,
    removeBuyTicketsSessionItem,
    clearAllBuyTicketsSession,
    handleAddQuantity,
    handleSubtractQuantity,
  }
}
